import React, { PureComponent } from "react";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import { PullToRefresh } from "antd-mobile";
/**
 * 仿 RN ScrollView
 * @class
 * @version 1.0.0
 */

export class ScrollView extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollStartTop = 0;

    this.handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

      if (scrollTop || scrollTop === 0) {
        const {
          onScrollStart,
          onScroll
        } = this.props;

        if (!this.scrolling) {
          this.scrolling = true;
          this.scrollStartTop = scrollTop;
          onScrollStart && onScrollStart(scrollTop);
        }

        onScroll && onScroll(scrollTop); // 下拉刷新条件判断

        const clientHeight = window.innerHeight; // 模拟scrollEnd触发条件

        this.handleScrollEnd(scrollTop, clientHeight);
      }
    };

    this.handleScrollEnd = debounce((scrollTop, clientHeight) => {
      if (this.scrolling) {
        const {
          onScrollEnd,
          onEndReachedThreshold = 0.5
        } = this.props;
        onScrollEnd && onScrollEnd(scrollTop);
        this.scrolling = false;

        if (scrollTop > this.scrollStartTop) {
          const scrollHeight = document.documentElement.scrollHeight > clientHeight ? document.documentElement.scrollHeight : document.body.scrollHeight;

          if (scrollTop + clientHeight + onEndReachedThreshold * clientHeight > scrollHeight) {
            this.handleEndReached();
          }
        }
      }
    }, 100);
    this.handleEndReached = throttle(() => {
      this.props.onEndReached && this.props.onEndReached();
    }, this.props.endReachedTime);
    this.scrolling = false;
    this.scrollEndTimer = 0;
    this.refreshingTimer = 0;
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    if (this.scrollEndTimer) {
      clearTimeout(this.scrollEndTimer);
    }

    if (this.refreshingTimer) {
      clearTimeout(this.refreshingTimer);
    }

    window.removeEventListener("scroll", this.handleScroll);
  }

  init() {
    window.addEventListener("scroll", this.handleScroll);
  }

  render() {
    const {
      children,
      onRefresh
    } = this.props;

    if (onRefresh) {
      return React.createElement(PullToRefresh, {
        headHeight: 60,
        threshold: 25,
        onRefresh: onRefresh
      }, children);
    }

    return children;
  }

}
ScrollView.defaultProps = {
  endReachedTime: 200
};